import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart-on",
  "use": "icon-heart-on-usage",
  "viewBox": "0 0 30 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 25\" id=\"icon-heart-on\">\n    <path d=\"M15 24.388C27.277 15.7 32.626 8.201 27.688 2.82 25.564.505 22.895.028 19.888.905c-1.09.318-2.152.797-3.148 1.373-.632.366-1.123.702-1.434.942L15 3.457l-.305-.237c-.312-.24-.803-.576-1.434-.942A14.373 14.373 0 0 0 10.11.905C7.107.028 4.437.505 2.313 2.819-2.626 8.201 2.722 15.701 15 24.39z\" fill=\"#FF005B\" stroke=\"#FF005B\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol